import { PanelRow, ToggleControl } from '@wordpress/components';
import { sprintf, _n, __ } from '@wordpress/i18n';
import { dispatch, useSelect } from '@wordpress/data';
const __i18n = {
	..._wp_travel_admin.strings
}
export default ({allDatas}) => {

    const { updateTripData } = dispatch('WPTravel/TripEdit')
    const { enable_pax_all_pricing, highest_price, send_itinerary_pdf } = allDatas;
    return  <>
        <PanelRow>
            <label>{__i18n.highest_price}</label>
            <ToggleControl 
                checked={ highest_price }
                help={__i18n.highest_price_description}
                onChange={ () => {
                    updateTripData({
                        ...allDatas,
                        highest_price:! highest_price
                    })
                } }
            />
        </PanelRow>
        <PanelRow>
            <label>{__i18n.enable_pax_individual}</label>
            <ToggleControl 
                checked={ enable_pax_all_pricing }
                help={__i18n.enable_pax_individual_description}
                onChange={ () => {
                    updateTripData({
                        ...allDatas,
                        enable_pax_all_pricing:! enable_pax_all_pricing
                    })
                } }
            />
        </PanelRow>
    </>
}
